import type { StripeElementLocale } from '@stripe/stripe-js'

const stripeLocaleByAppLanguage: Record<string, StripeElementLocale> = {
  de: 'de',
  en: 'en',
  ru: 'ru',
  tr: 'tr',
}

const DEFAULT_LANGUAGE: StripeElementLocale = 'en'

export const getStripeLocale = (language: string): StripeElementLocale =>
  stripeLocaleByAppLanguage[language] ?? DEFAULT_LANGUAGE
